import { Grid, FormControl, TextField, CircularProgress } from "@material-ui/core"
import Container from '../../components/layout/Container'
import React, { useState, useEffect, useCallback } from 'react'
import Button from '@material-ui/core/Button'
import Dropzone from '../../components/lab/DropZone'
import SolicitacaoService from "../../services/SolicitacaoService"
import { useSnackbar } from "notistack"
import PrivateRoute from '../../auth/private-route'
import { useAuth } from 'react-oidc-context'
import webconfig from "../../webconfig.json"

export default function Solicitacao(props) {
    const auth = useAuth();
    const nomeDoUsuario = auth?.user?.profile?.name;
    const emailDoUsuario = auth?.user?.profile?.email;

    const [nomeSolicitante, setNomeSolicitante] = useState('')
    const [nomeSolicitanteError, setNomeSolicitanteError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [telefoneSolicitante, setTelefoneSolicitante] = useState('')
    const [telefoneSolicitanteError, setTelefoneSolicitanteError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [emailSolicitante, setEmailSolicitante] = useState('')
    const [emailSolicitanteError, setEmailSolicitanteError] = useState({
        errorState: false,
        errorHelperText: ''
    })

    const [files, setFiles] = useState([]);
    const [progressoUploadArquivo, setProgressoUploadArquivo] = useState({
        emProgresso: false,
        porcentagem: 0
    })

    const [loading, setLoading] = useState(false)

    const { enqueueSnackbar } = useSnackbar()

    const cpfUsuario = useCallback(() => {
        const user = auth.user
        if (
            user !== undefined &&
            user.profile.preferred_username !== undefined
        ) {
            let cpf = user.profile.preferred_username
            let numeroCpf = cpf
            numeroCpf = numeroCpf.replace(/\D/g, '')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1-$2')
                .replace(/(-\d{2})\d+?$/, '$1')
            return numeroCpf
        }

        return ''
    }, [auth])

    useEffect(() => {
        if (nomeDoUsuario !== undefined && nomeDoUsuario !== null) {
            setNomeSolicitante(nomeDoUsuario);
        }

        if (emailDoUsuario !== undefined && emailDoUsuario !== null) {
            setEmailSolicitante(emailDoUsuario);
        }

    }, [nomeDoUsuario, emailDoUsuario]);

    function RealizaSolicitacao() {
        let formData = new FormData()
        files.forEach(file => {
            var tipoAquivo = file.name.substr(file.name.lastIndexOf('.') + 1, file.name.length)
            formData.append(tipoAquivo, file)
        })

        setProgressoUploadArquivo(prevState => ({
            ...prevState,
            emProgresso: true,
        }))

        setLoading(true);
        SolicitacaoService.Upload(
            cpfUsuario(),
            nomeSolicitante,
            emailSolicitante,
            telefoneSolicitante,
            formData,
            setProgressoUploadArquivo)
            .then(response => {
                setLoading(false);
                switch (response.status) {
                    case (201):
                        enqueueSnackbar(`Solicitação registrada com sucesso! Aguarde a confirmação ou não por e-mail.`, { variant: "success", autoHideDuration: webconfig.snackbarAutoHideDuration })
                        handleCancelaSolicitacaoAcesso()
                        return

                    default:
                        enqueueSnackbar(`${response.data}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                        break
                }

                setProgressoUploadArquivo((prevState) => ({
                    ...prevState,
                    emProgresso: false,
                }))
            })
            .catch(error => {
                setLoading(false);
                setProgressoUploadArquivo({
                    emProgresso: false,
                    porcentagem: 0
                })
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        const validacao = JSON.parse(error.response.data.detail)
                        let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): "
                        for (let i = 0; i < validacao.Validacoes.length; i++) {

                            var itemValidado = validacao.Validacoes[i]
                            for (var propriedadeValidada in itemValidado) {
                                mensagem += itemValidado[propriedadeValidada]
                            }

                            if ((i + 1) < validacao.Validacoes.length) {
                                mensagem += "; "
                            }
                        }

                        enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    const handleCancelaSolicitacaoAcesso = () => {
        window.location.href = '/Dashboard'
    }

    const divAction = {
        textAlign: "End",
        padding: "10px 0px 10px 10px"
    }

    const btnCancel = {
        marginRight: "10px"
    }

    const DownloadTermoAdesao = () => {
        setLoading(true)
        SolicitacaoService.DownloadTermoAdesao()
            .then(response => {
                if (response.status === 200) {
                    let extensionFile = response.data.tipoArquivo
                    let a = document.createElement("a")
                    a.href = `data:${extensionFile};base64,${response.data.conteudo}`
                    a.download = response.data.nomeArquivo
                    a.click()

                    enqueueSnackbar('Download realizado com sucesso', { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
                    setLoading(false)
                }
                else {
                    enqueueSnackbar('Não foi possível fazer donwload do Ofício. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
                }

            })
            .catch(error => {
                setLoading(false)
                if (error.response && error.response.data) {
                    if (error.response.status === 422) {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else if (error.response.status === 500) {
                        enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                    else {
                        enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                    }
                }
                else {
                    enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
                }
            })
    }

    return (
        <PrivateRoute rolesAllowed={props.roles}>
            <Container title="Solicitação de Acesso do Gestor">
                <div id="ContainerPage">
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <FormControl variant="outlined">
                                <TextField
                                    id="outlined-basic-ticket"
                                    variant="outlined"
                                    type="text"
                                    label="CPF"
                                    value={cpfUsuario()}
                                    inputProps={{
                                        maxLength: 14
                                    }}
                                    disabled={true}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <FormControl variant="outlined">
                                <TextField
                                    id="outlined-basic-ticket"
                                    variant="outlined"
                                    type="text"
                                    label="Nome Completo"
                                    value={nomeSolicitante}
                                    onChange={event => setNomeSolicitante(event.target.value)}
                                    error={nomeSolicitanteError.errorState}
                                    helperText={nomeSolicitanteError.errorHelperText}
                                    inputProps={{
                                        maxLength: 100
                                    }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <FormControl variant="outlined">
                                <TextField
                                    id="outlined-basic-ticket"
                                    variant="outlined"
                                    type="text"
                                    label="Telefone"
                                    value={telefoneSolicitante}
                                    onChange={event => {
                                        let numeroTelefone = event.target.value
                                        numeroTelefone = numeroTelefone.replace(/\D/g, '')
                                            .replace(/(\d{2})(\d)/, '($1) $2')
                                            .replace(/(\d{5})(\d)/, '$1-$2')
                                            .replace(/(-\d{4})\d+?$/, '$1')
                                        setTelefoneSolicitante(numeroTelefone)
                                    }}
                                    error={telefoneSolicitanteError.errorState}
                                    helperText={telefoneSolicitanteError.errorHelperText}
                                    inputProps={{
                                        maxLength: 15
                                    }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <FormControl variant="outlined">
                                <TextField
                                    id="outlined-basic-ticket"
                                    variant="outlined"
                                    type="text"
                                    label="E-mail"
                                    value={emailSolicitante}
                                    onChange={event => setEmailSolicitante(event.target.value)}
                                    error={emailSolicitanteError.errorState}
                                    helperText={emailSolicitanteError.errorHelperText}
                                    inputProps={{
                                        maxLength: 50
                                    }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <button
                                type="button"
                                onClick={DownloadTermoAdesao}
                                style={{
                                    cursor: "pointer",
                                    color: "blue",
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    font: "inherit",
                                    textDecoration: "underline"
                                }}
                            >
                                Download Formulário Cadastral
                            </button>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Dropzone files={files} setFiles={setFiles} maxFiles={1} />
                        </Grid>
                    </Grid>
                </div>
                <div style={divAction}>
                    <Button style={btnCancel} disabled={loading} onClick={handleCancelaSolicitacaoAcesso} className="bg-alternativo-4 txt-alternativo-3" >Cancelar</Button>
                    <Button
                        className="bg-primario txt-branco btn-salvar-default"
                        onClick={() => loading ? ('') : RealizaSolicitacao()}
                        style={{ float: "inline-end" }}>
                        {
                            loading
                                ?
                                <CircularProgress size={22} />
                                :
                                'Salvar'
                        }
                    </Button>
                </div>
                <br /><br /><br /><br />
            </Container >
        </PrivateRoute>
    )
}